/**
 * Attribution line for a fee/scholarship history row (Brief N1):
 *  - no recorded author (createdBy null)      → "System"
 *  - the signed-in viewer's own edit          → "<Real Name> (you)"
 *  - anyone else                              → "<Real Name>"
 *
 * The server resolves createdByName for every non-null createdBy, so a null
 * name alongside a non-null id is defensive only — it degrades to "System"
 * rather than ever rendering an empty or "undefined" name.
 */
export function editorLabel(
  v: { createdBy: string | null; createdByName: string | null },
  currentUserId: string | null | undefined,
): string {
  if (v.createdBy == null || v.createdByName == null) return 'System';
  return v.createdBy === currentUserId ? `${v.createdByName} (you)` : v.createdByName;
}
